import React from 'react';
import moment from 'moment';

export function getWeek(value, isNewInput = false){
    if (value&& value.length==2 && parseInt(value)==value && value>0 && value<54)
    {
      var currentWeekNumber = moment(new Date()).isoWeek();
      
      var year=(new Date().getFullYear()+((isNewInput && currentWeekNumber>=value)?1:0)).toString();
      return year+('0' + value).slice(-2);
    }
    else
     return value;
  }


  export function getCurrentWeek(currentWeek, currentDate)
  {
    var year = moment(currentDate).year();
    
    return year + ('0' + currentWeek).slice(-2);
  }

  export function getWeekFromDate(date, isNewInput = false){
      if(date.length > 0)
      {
        var currentWeekNumber = moment(date, "YYY-MM-DD").isoWeek() + 1; //Exmill offset, since exmill date is the sunday before the exmill week.
        let value = String(currentWeekNumber).padStart(2, '0');
        return isNewInput ? getWeek(value, isNewInput) : getCurrentWeek(value, date);
      }
      return '';

  }